import { DataStreamEntity } from './data-stream.entity.js';
import { OrganizationEntity } from './organization.entity.js';
import { ReceiverEntity } from '../receiver/receiver.entity.js';
import { UserEntity } from './user.entity.js';
import { TrackerEntity } from '../tracker/tracker.entity.js';
import { ClientEntity } from './client.entity.js';
import { SubjectEntity } from './subject.entity.js';
import { ClientStreamEntity } from '../client-stream/client-stream.entity.js';

export enum EntityKind
{
    User = 'user',
    Client = 'client',
    Subject = 'subject',
    Organization = 'organization',
    Receiver = 'receiver',
    DataStream = 'data_stream',
    Tracker = 'tracker',
    ClientStream = 'client_stream'
}

export const entityKindList: string[] = Object
    .values(EntityKind)
    .filter((kind: any) => isNaN(Number(kind)));

export interface EntityKindTypeMap
{
    [EntityKind.User]: UserEntity;
    [EntityKind.Client]: ClientEntity;
    [EntityKind.Subject]: SubjectEntity;
    [EntityKind.Organization]: OrganizationEntity;
    [EntityKind.Receiver]: ReceiverEntity;
    [EntityKind.DataStream]: DataStreamEntity;
    [EntityKind.Tracker]: TrackerEntity;
    [EntityKind.ClientStream]: ClientStreamEntity;
};

export const EntityKindConstructorMap = {
    [EntityKind.User]: UserEntity,
    [EntityKind.Client]: ClientEntity,
    [EntityKind.Subject]: SubjectEntity,
    [EntityKind.Organization]: OrganizationEntity,
    [EntityKind.Receiver]: ReceiverEntity,
    [EntityKind.DataStream]: DataStreamEntity,
    [EntityKind.Tracker]: TrackerEntity,
    [EntityKind.ClientStream]: ClientStreamEntity
};

export type EntityType<K extends keyof EntityKindTypeMap> = EntityKindTypeMap[K];

export function entityConstructor<K extends keyof EntityKindTypeMap>(kind: K)
{
    return EntityKindConstructorMap[kind];
}

export function newEntity<K extends keyof EntityKindTypeMap>(kind: K, value: Partial<EntityType<K>>): EntityType<K>
{
    const entity: EntityType<K> = new EntityKindConstructorMap[kind](value) as EntityType<K>;
    for(const k in value)
    {
        if(!(k in entity))
            entity[k] = value[k] as EntityType<K>[Extract<keyof EntityType<K>, string>];
    }
    return entity;
}

